import { RouteEnum } from '../constantes/RouteEnum';
import { pageConfigs } from '../configs/pageConfigs';

export interface NavigationScenario {
  isOpenFlow: boolean;
  currentFlow: string;
  isOnboardingRecovery?: boolean;
}

export const getNavigationDestination = (scenario: NavigationScenario): string => {
  const {isOpenFlow, currentFlow, isOnboardingRecovery} = scenario;
  
  if (isOpenFlow) {
    if (currentFlow === 'Onboarding') {
      return RouteEnum.FINISH;
    }
    
    return RouteEnum.HOME;
  }
  
  // Fluxo fechado
  if (currentFlow === 'Onboarding') {
    return pageConfigs.otpValidation.navigateTo();
  }
  
  // **CASO ESPECIAL**: Authentication mas precisa seguir fluxo de onboarding
  if (currentFlow === 'Authentication' && isOnboardingRecovery) {
    return pageConfigs.otpValidation.navigateTo();
  }
  
  return RouteEnum.HOME;
};
